import UserInfo from './UserInfo';

export default UserInfo;



// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/UserInfo/index.jsx